import { SubscriptionProductData } from "../../subscription/add-to-cart/subscription-add-to-cart";
import { SharpenSearchServiceProductData } from "../interfaces/sharpen-search-service-product-data.interface";

export function mapSharpenSearchServiceToSSubscriptionProductData(productData: SharpenSearchServiceProductData): SubscriptionProductData {
  return {
    isbn: productData.isbn,
    isbn13: productData.isbn13,
    mhid: productData.isbn,
    productTitle: productData.title,
    seoTitle: productData.seoTitle,
    description: '',
    copyrightYear: productData.copyrightYear + '',
    duration: productData.DURATION,
    durationPeriod: productData.DURATION_PERIOD,
    listPrice: productData.LIST_PRICE + '',
    netPrice: productData.NET_PRICE + '',
    availability: 'AVAILABLE',
    publishDate: productData.publicationDate + '',
    contributors: productData.contributors?.join(', ') || '',
    instructorComp: productData.INSTRUCTOR_COMP + '',
    isMaster: productData.IS_MASTER + '',
    offerPricingId: productData.OFFER_PRICING_ID,
  } as SubscriptionProductData;
}